import React from "react";

import { useProductContext } from "../ProductContext/ProductContext";
import { SKU } from "../engine";

import styles from "./SkuLine.module.scss";

type SkuLineProps = { sku: SKU };

export const SkuLine = ({ sku }: SkuLineProps) => {
    const { catalog } = useProductContext();
    const product = catalog.get(sku);
    if (!product) return null;
    return (
        <div>
            <div className={styles.sku}>{sku}</div>
            <div className={styles.name}>{product.name}</div>
            <div className={styles.price}>{product.msrp.formatted}</div>
        </div>
    );
};
